import genActTypes from '../core/types';

export default genActTypes('contact');
